import { useState } from 'react'
import SectionCard from './ui/SectionCard'
const Section = ({ children, title, className = 'width-100', expanded: controlledExpanded, onToggle, variant = 'accordion', collapsible = false, defaultOpen = true, action = null }) => {
    const [internalExpanded, setInternalExpanded] = useState(defaultOpen)
    const expanded = typeof controlledExpanded === 'boolean' ? controlledExpanded : internalExpanded
    const handleToggle = () => { if (onToggle) onToggle(!expanded); else setInternalExpanded(!expanded) }
    return <SectionCard title={title} actions={action} className={className} collapsible={variant === 'accordion' || collapsible} expanded={expanded} onToggle={handleToggle}>{children}</SectionCard>
}
export default Section
